module.exports = __webpack_public_path__ + "static/media/acompanamientos.4ade253a.svg";